import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { noticeInitData } from "../../constants/notice";

const initialState = noticeInitData;
const modifySlice = createSlice({
  name: "modify",
  initialState,
  reducers: {
    setModifyRegister: (state: NoticeRegisterType, action: PayloadAction<NoticeRegisterType>) => ({
      ...state,
      ...{
        needModifyData: action.payload.needModifyData ?? state.needModifyData,
        currentCategory: action.payload.currentCategory ?? state.currentCategory,
        title: action.payload.title ?? state.title,
        contents: action.payload.contents ?? state.contents,
        stores: action.payload.stores ?? state.stores,
        tempStores: action.payload.tempStores ?? state.tempStores,
        deleteTempStore: action.payload.deleteTempStore ?? state.deleteTempStore,
        dateToggle: action.payload.dateToggle ?? state.dateToggle,
        endDate: action.payload.endDate ?? state.endDate,
        importNotice: action.payload.importNotice ?? state.importNotice,
        fileList: action.payload.fileList ?? state.fileList,
        imageList: action.payload.imageList ?? state.imageList,
        limitImage: action.payload.limitImage ?? state.limitImage,
      },
    }),
    setModifyDataInit: (state: NoticeRegisterType) => initialState,
  },
});

export const { setModifyRegister, setModifyDataInit } = modifySlice.actions;

export default modifySlice.reducer;
